import React from "react";
import PropTypes from "prop-types";
import * as CurrencyFormat from 'react-currency-format';
import styled from "styled-components";
import { COLOR_GRAY_TEXT } from "../../constants/Colors";

const LogFormControl = styled(CurrencyFormat)`
  background-color: #f6f6f4;
  color: ${COLOR_GRAY_TEXT};
  border: none;
  width: 100%;
  padding: 13px 5px;
  border-radius: 2px;
  font-family: "arial" !important;
  margin-bottom: ${(props) => props.mb0 === "true" && 0}px !important;
  ::placeholder {
    padding-left: 14px !important;
    font-size: 14px;
    color: ${COLOR_GRAY_TEXT};
  }
  ::-moz-placeholder {
    padding-left: 14px !important;
    color: red;
    font-size: 14px;
    color: ${COLOR_GRAY_TEXT};
    text-indent: 10px;
  }
`;

const LogInputCurrency = ({
  placeholder,
  className,
  errors,
  messageError,
  name,
  ...rest
}) => {
  let mb0 = errors[name] ? "true" : "false";
  return (
    <>
      <LogFormControl
        {...{ ...rest, name, mb0 }}
        className={`${className}  ${errors[name] && "is-invalid"}`}
        placeholder={placeholder}
      />
      {errors[name] && (
        <div className="mb-2 mt-0">
          <small className="text-danger">{errors[name]}.</small>
        </div>
      )}
    </>
  );
};

LogInputCurrency.propTypes = {
  placeholder: PropTypes.string,
  className: PropTypes.string,
};

export default LogInputCurrency;
